import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_003.jpg';

page.games = [
  {
    id: 'page003_game1',
    icon: 'ikonaCwiczenie',
    color: '#FF808080',
    tooltip: 's. 3',
    pos: {
      x: RIGHT,
      y: 40,
    },
    items: [
      {
        id: 'page003_game1',
      },
      {
        id: 'page003_game2',
      },
      {
        id: 'page003_game3',
      },
    ],
  },
];
export default page;
